import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="col-span-1 md:col-span-2">
            <img src="https://public.readdy.ai/ai/img_res/a37d52a8-201a-4b92-9b36-08215345d1df.png" alt="LearnFlow" className="h-9 w-auto mb-4 brightness-200" />
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
              Empowering learners worldwide with high-quality courses, hands-on projects, and expert instructors. Your journey to mastery starts here.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-twitter-x-line', 'ri-linkedin-fill', 'ri-youtube-fill', 'ri-instagram-line'].map((icon, i) => (
                <a key={i} href="#" className="w-9 h-9 flex items-center justify-center bg-slate-800 hover:bg-teal-600 rounded-lg transition-colors cursor-pointer">
                  <i className={`${icon} text-sm text-slate-300`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Platform</h4>
            <ul className="space-y-2.5">
              {[['Courses', '/courses'], ['Dashboard', '/dashboard'], ['Sign In', '/login'], ['Get Started', '/signup']].map(([label, to]) => (
                <li key={label}>
                  <Link to={to} className="text-slate-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Categories</h4>
            <ul className="space-y-2.5">
              {['Web Development', 'Data Science', 'UI/UX Design', 'Digital Marketing', 'Photography', 'Business'].map(cat => (
                <li key={cat}>
                  <Link to="/courses" className="text-slate-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">{cat}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-sm">&copy; {new Date().getFullYear()} LearnFlow. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-slate-500 hover:text-slate-300 text-sm cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-slate-500 hover:text-slate-300 text-sm cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
